import React from 'react';
import ProductRequestsAdmin from '@/components/ProductRequestsAdmin';

export default function ProductRequests() {
  return (
    <div className="p-6 space-y-6" data-testid="product-requests-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">New Product Requests</h1>
          <p className="text-sm text-slate-500 mt-1">
            Review and act on product proposals submitted by your stores. Approved items still need to
            be added to the Master Catalogue manually.
          </p>
        </div>
      </div>
      <ProductRequestsAdmin />
    </div>
  );
}
